// ABOUTME: Maps icon name strings from settings JSON to @ds/coolshop icon components.
// ABOUTME: Provides a finite lookup with a default fallback icon; names stay the config keys, the icons are the outlined twins.

import {
    AccountTreeOutlinedIcon,
    ArticleOutlinedIcon,
    AssessmentOutlinedIcon,
    AutorenewOutlinedIcon,
    BarChartOutlinedIcon,
    BuildOutlinedIcon,
    BusinessCenterOutlinedIcon,
    CalendarTodayOutlinedIcon,
    CancelOutlinedIcon,
    CategoryOutlinedIcon,
    CheckCircleOutlinedIcon,
    CheckOutlinedIcon,
    CloudSyncOutlinedIcon,
    ContactsOutlinedIcon,
    DashboardOutlinedIcon,
    DescriptionOutlinedIcon,
    DoneAllOutlinedIcon,
    EditOutlinedIcon,
    ExtensionOutlinedIcon,
    FiberNewOutlinedIcon,
    FolderOutlinedIcon,
    HandymanOutlinedIcon,
    HelpOutlineOutlinedIcon,
    HourglassEmptyOutlinedIcon,
    ImageOutlinedIcon,
    InfoOutlinedIcon,
    InventoryOutlinedIcon,
    LanguageOutlinedIcon,
    LayersOutlinedIcon,
    ListOutlinedIcon,
    LocalOfferOutlinedIcon,
    LocalShippingOutlinedIcon,
    MenuBookOutlinedIcon,
    PersonOutlinedIcon,
    PictureAsPdfOutlinedIcon,
    PrecisionManufacturingOutlinedIcon,
    ReceiptOutlinedIcon,
    ScheduleOutlinedIcon,
    SearchOutlinedIcon,
    SendOutlinedIcon,
    SettingsOutlinedIcon,
    ShoppingCartOutlinedIcon,
    SupportAgentOutlinedIcon,
    TaskAltOutlinedIcon,
    TranslateOutlinedIcon,
    VideoFileOutlinedIcon,
    ViewInArOutlinedIcon,
    WorkOutlinedIcon,
} from '@ds/coolshop';
import { ReactElement } from 'react';

const iconMap: Record<string, ReactElement> = {
    AccountTreeIcon: <AccountTreeOutlinedIcon />,
    ArticleIcon: <ArticleOutlinedIcon />,
    AssessmentIcon: <AssessmentOutlinedIcon />,
    BarChartIcon: <BarChartOutlinedIcon />,
    BuildIcon: <BuildOutlinedIcon />,
    BusinessCenterIcon: <BusinessCenterOutlinedIcon />,
    CalendarTodayIcon: <CalendarTodayOutlinedIcon />,
    CategoryIcon: <CategoryOutlinedIcon />,
    CheckIcon: <CheckOutlinedIcon />,
    CloudSyncIcon: <CloudSyncOutlinedIcon />,
    DashboardIcon: <DashboardOutlinedIcon />,
    ContactsIcon: <ContactsOutlinedIcon />,
    DescriptionIcon: <DescriptionOutlinedIcon />,
    ExtensionIcon: <ExtensionOutlinedIcon />,
    FolderIcon: <FolderOutlinedIcon />,
    HandymanIcon: <HandymanOutlinedIcon />,
    ImageIcon: <ImageOutlinedIcon />,
    InfoIcon: <InfoOutlinedIcon />,
    InventoryIcon: <InventoryOutlinedIcon />,
    LanguageIcon: <LanguageOutlinedIcon />,
    LayersIcon: <LayersOutlinedIcon />,
    ListIcon: <ListOutlinedIcon />,
    LocalOfferIcon: <LocalOfferOutlinedIcon />,
    MenuBookIcon: <MenuBookOutlinedIcon />,
    PersonIcon: <PersonOutlinedIcon />,
    PictureAsPdfIcon: <PictureAsPdfOutlinedIcon />,
    PrecisionManufacturingIcon: <PrecisionManufacturingOutlinedIcon />,
    ReceiptIcon: <ReceiptOutlinedIcon />,
    ScheduleIcon: <ScheduleOutlinedIcon />,
    SearchIcon: <SearchOutlinedIcon />,
    SettingsIcon: <SettingsOutlinedIcon />,
    TranslateIcon: <TranslateOutlinedIcon />,
    VideoFileIcon: <VideoFileOutlinedIcon />,
    ViewInArIcon: <ViewInArOutlinedIcon />,
    WorkIcon: <WorkOutlinedIcon />,
    // Workflow state chips.
    AutorenewIcon: <AutorenewOutlinedIcon />,
    CancelIcon: <CancelOutlinedIcon />,
    CheckCircleIcon: <CheckCircleOutlinedIcon />,
    DoneAllIcon: <DoneAllOutlinedIcon />,
    EditIcon: <EditOutlinedIcon />,
    FiberNewIcon: <FiberNewOutlinedIcon />,
    HelpOutlineIcon: <HelpOutlineOutlinedIcon />,
    HourglassEmptyIcon: <HourglassEmptyOutlinedIcon />,
    LocalShippingIcon: <LocalShippingOutlinedIcon />,
    SendIcon: <SendOutlinedIcon />,
    ShoppingCartIcon: <ShoppingCartOutlinedIcon />,
    SupportAgentIcon: <SupportAgentOutlinedIcon />,
    TaskAltIcon: <TaskAltOutlinedIcon />,
};

const defaultIcon = <ListOutlinedIcon />;

export function resolveIcon(iconName?: string | null): ReactElement {
    if (!iconName) return defaultIcon;
    return iconMap[iconName] ?? defaultIcon;
}
